import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/operator/map';


@Injectable()
export class RegistrationService {
	constructor(private http: HttpClient) { }

	//private baseUrl = 'http://192.168.1.20:8080/nburecruitment/';
	//private baseUrl = 'http://45.79.217.254:8080/nburecruitment/';
	private baseUrl = 'https://74.207.237.211:8443/nburecruitment/';   //main  "https://74.207.237.211/NBU/"
    // private baseUrl = 'http://45.33.96.252:8080/nburecruitment/';        //demo  "http://45.33.96.252/NBU/"

	staffLogin(data) {
		return this.http
			.post(this.baseUrl + 'staff-login', data)
			.toPromise()
			.then(res => res);
    }

    getAdvList() {
		return this.http
		.get(this.baseUrl + 'recruitment-advlist')
		.toPromise()
		.then(res => res);
	}

	getCommonList(advid) {
		return this.http
		.get(this.baseUrl + 'recruitment-commonList/' +advid)
		.toPromise()
		.then(res => res);
	}

	getAllCandidateList(id,advid) {
		return this.http
		.get(this.baseUrl + 'recruitment-allCandidateList/' + id +'/' + advid)
		.toPromise()
		.then(res => res);
	}
	savestaffData(data) {
		return this.http
		.post(this.baseUrl + 'submit-recruitment', data)
		.toPromise()
		.then(res => res);
	}
	getStaffDetails(id) {
		return this.http
		.get(this.baseUrl + 'getRecDetails/' + id)
		.toPromise()
		.then(res => res);
	}

	addMaster(value, name) {
		return this.http
		.get(this.baseUrl + 'addMaster/' + value + '/' + name)
		.toPromise()
		.then(res => res);
	}

	deleteExperienceByid(id) {
		return this.http
		.delete(this.baseUrl + 'expDataDelete/' + id)
		.toPromise()
		.then(res => res);
	}

	deleteRecDetailsbyId(id) {
		return this.http
		.delete(this.baseUrl + 'delete-recruitment-dtlsById/' + id)
		.toPromise()
		.then(res => res);
	}
	printForm(data,flg,advid) {
		return this.http
		.post(this.baseUrl + 'print-staffrecruitment-form/'+flg+'/'+advid, data)
		.toPromise()
		.then(res => res);
	}

	printscoresheet(data,flg,advid) {
		return this.http
		.post(this.baseUrl + 'print-StaffRecruitment-ScoreCard/'+flg+'/'+advid, data)
		.toPromise()
		.then(res => res);
	}

	loadCandidateList(did,pcid,pid,advid) {
		return this.http
		.get(this.baseUrl + 'load-candidatelist-with-score/'+did+'/'+pcid+'/'+pid+'/'+advid)
		.toPromise()
		.then(res => res);
	}
	saveinterviewdate(data,advid) {
		return this.http
		.post(this.baseUrl + 'print-interviewcall/'+advid, data)
		.toPromise()
		.then(res => res);
	}
	saveResearchPerform(data){
		return this.http
		.post(this.baseUrl + 'update-researchperform', data)
		.toPromise()
		.then(res => res);
	}
	sendSmsForInterview(data,advid){
		return this.http
		.post(this.baseUrl + 'send-sms-for-interview/'+advid, data)
		.toPromise()
		.then(res => res);
	}

	printCandidateListByPost(data,advid) {
		return this.http
		.post(this.baseUrl + 'print-candidate-list/'+advid, data)
		.toPromise()
		.then(res => res);
    }

    docupload(data, flg) {
		return this.http.post(this.baseUrl + 'doc-upload/' + flg, data)
			.toPromise()
			.then(res => res);
    }

	//add by JD for LPC certificate
	uploadlpc(data, flg) {
		// console.log(data, flg);
		return this.http.post(this.baseUrl + 'doc-upload-experience/' + flg, data)
			.toPromise()
			.then(res=> res);
	}
	//end by JD

    docuploadacademics(data, flg) {
		// console.log(data, flg);
		return this.http.post(this.baseUrl + 'doc-upload-academics/' + flg, data)
			.toPromise()
			.then(res => res);
    }

    getformchallan(id) {
		return this.http
		.get(this.baseUrl + 'getformchallan/' + id)
		.toPromise()
		.then(res => res);
    }

    getApplicationListService(applicationid) {
		return this.http
		.get(this.baseUrl + 'applicant-data/' +applicationid)
		.toPromise()
		.then(res => res);
	}

    // ----------
    printallapplform(advid,pid,pcid) {
		return this.http
		.get(this.baseUrl + 'print-allapplform/'+advid+'/'+pid+'/'+pcid)
		.toPromise()
		.then(res => res);
	}
    // ----------


}



// WEBPACK FOOTER //
// ./src/app/services/registration.service.ts